import { useEffect, useState } from 'react'
import { useIsOffline } from '../hooks/useIsOffline'
import { useI18n } from '../stores/I18nContext'
import './StatusBanners.css'

/**
 * Top-of-app banners for PWA lifecycle events:
 *  - Offline state (read-only mode).
 *  - "Update available" toast (from vite-plugin-pwa registerSW).
 *  - "Ready offline" one-time toast (precache complete).
 */
export default function StatusBanners() {
  const { language } = useI18n()
  const isNorwegian = language === 'nb'
  const isOffline = useIsOffline()
  const [updateSW, setUpdateSW] = useState(null)
  const [offlineReady, setOfflineReady] = useState(false)

  useEffect(() => {
    const onUpdate = (e) => setUpdateSW(() => e.detail?.updateSW || null)
    const onReady = () => setOfflineReady(true)
    window.addEventListener('teddo:pwa-update-available', onUpdate)
    window.addEventListener('teddo:pwa-offline-ready', onReady)
    return () => {
      window.removeEventListener('teddo:pwa-update-available', onUpdate)
      window.removeEventListener('teddo:pwa-offline-ready', onReady)
    }
  }, [])

  return (
    <>
      {isOffline && (
        <div className="status-banner status-banner--offline" role="status">
          <span>
            {isNorwegian
              ? 'Offline — viser sist synkroniserte versjon. Redigering er deaktivert.'
              : 'Offline — viewing last synced version. Editing is disabled.'}
          </span>
        </div>
      )}
      {updateSW && (
        <div className="status-banner status-banner--update" role="status">
          <span>
            {isNorwegian ? 'Ny versjon tilgjengelig.' : 'A new version is available.'}
          </span>
          <button
            type="button"
            onClick={() => {
              try { updateSW(true) } catch {}
              setUpdateSW(null)
            }}
          >
            {isNorwegian ? 'Oppdater' : 'Reload'}
          </button>
        </div>
      )}
      {offlineReady && !isOffline && (
        <div className="status-banner status-banner--info" role="status">
          <span>
            {isNorwegian
              ? 'Klar for offline-bruk.'
              : 'Ready to work offline.'}
          </span>
          <button type="button" onClick={() => setOfflineReady(false)}>
            ×
          </button>
        </div>
      )}
    </>
  )
}
